import AreaChip from "Components/Common/Chip/AreaChip";
import RoleIcon from "Components/Icon/RoleIcon";
import i18n from "i18next";
import AttachFileIcon from "mdi-react/AttachFileIcon";
import InformationOutlineIcon from "mdi-react/InformationOutlineIcon";
import { AuditTemplate } from "Models/Audit/AuditTemplate";
import * as React from "react";
import { connect } from "react-redux";
import { IAuditTemplateState } from "Store/AuditTemplates/AuditTemplateState";
import { IApplicationState } from "Store/Store";
import styles from "./AuditTemplateBlockDetailsBlock.scss";

interface IProps {
    auditTemplate: AuditTemplate;
    auditTemplateState: IAuditTemplateState;
}

const mapStateToProps = (state: IApplicationState) => ({
    auditTemplateState: state.auditTemplateState
});

const AuditTemplateBlockDetailsBlock: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={styles.auditTemplateBlockDetailsBlock}>
        <div className={styles.info}>
            <div className={styles.identifier}>{i18n.t("common.id")}: {props.auditTemplate.id}</div>
            <div className={styles.taskTemplates}>
                <span className={styles.infoValue}>{i18n.t("common.items")}: {props.auditTemplate.items.length}</span>
            </div>
            <div className={styles.attachment}>
                <span className={styles.infoValue}>{i18n.t("common.instructions")}: {props.auditTemplate.totalInstructionCount}</span>
            </div>
        </div>
        <h2>{props.auditTemplate.name}</h2>
        <div className={styles.bottomInfo}>
            <div className={styles.role}>
                {i18n.t("authentication.role")}: {i18n.t(`authentication.roles.${props.auditTemplate.role}`)}
            </div>
            {props.auditTemplate.area && <AreaChip area={props.auditTemplate.area} size="small" maxPathLength={85} filteredArea={props.auditTemplateState.currentFilter && props.auditTemplateState.currentFilter.area} />}
        </div>
    </div>
);

export default connect(mapStateToProps, null)(AuditTemplateBlockDetailsBlock);


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockView/AuditTemplateBlockCard/AuditTemplateBlockDetailsBlock/AuditTemplateBlockDetailsBlock.tsx